import React, { useEffect, useState } from 'react';
import urlHelper from '../../utils/urlHelper';
import commonFunctions from '../../utils/commonFunctions';
import axios from 'axios';
import asyncRequest from '../../utils/asyncRequest';

import CircularProgress from '@material-ui/core/CircularProgress';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Grey from '@material-ui/core/colors/grey';

import _map from 'lodash/map';
import _groupBy from 'lodash/groupBy';
import _each from 'lodash/each';
import _orderBy from 'lodash/orderBy';

const useStyles = makeStyles((theme) => ({
  loader: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    zIndex: '9999',
  },
  table: {
      backgroundColor: Grey[200],
      marginTop: theme.spacing(.5),
  },
  tableRow: {
      verticalAlign: 'top',
      '&:nth-of-type(even)': {
          backgroundColor: Grey[200],
      },
      '&:nth-of-type(odd)': {
          backgroundColor: '#fff',
      },
  },
  tableContainer: {
      width: '100%',
  },
  marginTopBottom: {
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
  },
  accordionSummary: {
      margin: "0px auto",
  },
  accordionSummaryBlue: {
      backgroundColor : theme.palette.info.light,
      margin: "0px auto",
  },
}));

function Info() {

  const [employeeId] = useState(commonFunctions.getUserEmployeeId());

  const [myAwardsCurrentYear, setMyAwardsCurrentYear] = useState([]);
  const [myAwardsFollowingYear, setMyAwardsFollowingYear] = useState([]);
  const [allAwardsCurrentYear, setAllAwardsCurrentYear] = useState([]);
  const [allAwardsFollowingYear, setAllAwardsFollowingYear] = useState([]);
  const [slotsAvailableCurrentYear, setSlotsAvailableCurrentYear] = useState([]);
  const [slotsAvailableFollowingYear, setSlotsAvailableFollowingYear] = useState([]);

  const [open_ErrorDialog, setOpen_ErrorDialog] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState('');

  const [showLoader, setShowLoader] = useState(true);
  const currentYear = new Date().getFullYear();
  const followingYear = new Date().getFullYear() + 1;

  const classes = useStyles();

  useEffect(() => {
    const url1 = urlHelper.getAwards(employeeId, currentYear);
    const url2 = urlHelper.getAwards(employeeId, followingYear);
    const url3 = urlHelper.getAllAwards(employeeId, currentYear);
    const url4 = urlHelper.getAllAwards(employeeId, followingYear);
    const url5 = urlHelper.getAvailableSlots(employeeId, currentYear);
    const url6 = urlHelper.getAvailableSlots(employeeId, followingYear);

    axios.all(
      [asyncRequest.get(url1), asyncRequest.get(url2), asyncRequest.get(url3), asyncRequest.get(url4), asyncRequest.get(url5), asyncRequest.get(url6)]
      )
    .then(function(response) { 
      setMyAwardsCurrentYear(response[0].data);
      setMyAwardsFollowingYear(response[1].data);

      // group all awards by month then order by start date
      var currentYearAwards = _each(_groupBy(response[2].data, 'month'), function (group){
        _orderBy(group, 'startDate');
      });
      var followingYearAwards = _each(_groupBy(response[3].data, 'month'), function (group){
        _orderBy(group, 'startDate');
      });
      
      setAllAwardsCurrentYear(currentYearAwards);
      setAllAwardsFollowingYear(followingYearAwards);
      
      // group available slots by month then order by slot date
      var slotsCurrentYear = _each(_groupBy(response[4].data, 'month'), function (group){
        _orderBy(group, 'slotDate');
      });
      var slotsFollowingYear = _each(_groupBy(response[5].data, 'month'), function (group){
        _orderBy(group, 'slotDate');
      });

      setSlotsAvailableCurrentYear(slotsCurrentYear);
      setSlotsAvailableFollowingYear(slotsFollowingYear);

      setShowLoader(false);
    
    })
    .catch((error) => {
        console.log('error', error);
        setErrorDialogMessage("An unexpected error occurred. " + error.message);
        setOpen_ErrorDialog(true);
        setShowLoader(false);
      });
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose_ErrorDialog = () => {
    setOpen_ErrorDialog(false);
  };

  return (
    <>
      <div>
      <Typography variant="h5" className={classes.marginTopBottom}>{currentYear}</Typography>
        {/* MY AWARDS CURRENT YEAR */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
            <Typography variant="h6">My Awards</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {myAwardsCurrentYear.length !== 0 && (
                <Grid item xs={12} className ={classes.tableContainer}>
                    <TableContainer component={Paper}>
                        <Table size="small" className={classes.table}>
                          <TableHead>
                            <TableRow>
                              <TableCell>Vacation Number</TableCell>
                              <TableCell>Bid Rank</TableCell>
                              <TableCell>Start Date</TableCell>
                              <TableCell>Inclusive End Date</TableCell>
                              <TableCell>Number of Days</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                          {myAwardsCurrentYear && _map(myAwardsCurrentYear, i => (
                            <TableRow key={i.id} className={classes.tableRow}>
                              <TableCell align="left">{i.vacationNumber}</TableCell>
                              <TableCell align="left">{i.bidRank}</TableCell>
                              <TableCell align="left">{commonFunctions.formatDate_Date(i.startDate)}</TableCell>
                              <TableCell align="left">{commonFunctions.formatDate_Date(i.inclusiveEndDate)}</TableCell>
                              <TableCell align="left">{commonFunctions.calculateNumberOfDays(i.startDate, i.inclusiveEndDate)}</TableCell>
                            </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* ALL AWARDS CURRENT YEAR */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">All Awards</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
                  <Grid item xs={12} className ={classes.tableContainer}>
                  {allAwardsCurrentYear && _map(allAwardsCurrentYear, (object, index) => (
                    <Accordion key={index}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummaryBlue}>
                        <Typography variant="body1">{commonFunctions.formatMonth(object[0].month)}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <TableContainer component={Paper}>
                            <Table size="small" className={classes.table}>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Name</TableCell>
                                  <TableCell>Start Date</TableCell>
                                  <TableCell>Inslusive End Date</TableCell>
                                  <TableCell>Number of Days</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                              {_map(object, (innerObject, innerIndex) => (
                                <TableRow key={innerObject.id} className={classes.tableRow}>
                                  <TableCell align="left">{innerObject.employeeName}</TableCell>
                                  <TableCell align="left">{commonFunctions.formatDate_Date(innerObject.startDate)}</TableCell>
                                  <TableCell align="left">{commonFunctions.formatDate_Date(innerObject.inclusiveEndDate)}</TableCell>
                                  <TableCell align="left">{commonFunctions.calculateNumberOfDays(innerObject.startDate, innerObject.inclusiveEndDate)}</TableCell>
                                </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                        </TableContainer>
                      </AccordionDetails>
                      </Accordion>
                      ))}
                  </Grid>
              </Grid>
          </AccordionDetails>
        </Accordion>
        {/* SLOTS AVAILABLE CURRENT YEAR*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Slots Available</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
                  <Grid item xs={12} className ={classes.tableContainer}>
                  {slotsAvailableCurrentYear && _map(slotsAvailableCurrentYear, (object, index) => (
                    <Accordion key={index}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummaryBlue}>
                        <Typography variant="body1">{commonFunctions.formatMonth(object[0].month)}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <TableContainer component={Paper}>
                            <Table size="small" className={classes.table}>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Date</TableCell>
                                  <TableCell>Starting Count</TableCell>
                                  <TableCell>Count of Awards</TableCell>
                                  <TableCell>Available Slots</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                              {_map(object, (innerObject, innerIndex) => (
                                <TableRow key={innerObject.id} className={classes.tableRow}>
                                  <TableCell align="left">{commonFunctions.formatDate_Date(innerObject.slotDate)}</TableCell>
                                  <TableCell align="left">{innerObject.startingSlotCount}</TableCell>
                                  <TableCell align="left">{innerObject.countOfAwards}</TableCell>
                                  <TableCell align="left">{innerObject.availSlotsForDay}</TableCell>
                                  
                                </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                        </TableContainer>
                      </AccordionDetails>
                      </Accordion>
                      ))}
                  </Grid>
              </Grid>
          </AccordionDetails>
        </Accordion>

        <Typography variant="h5" className={classes.marginTopBottom}>{followingYear}</Typography>
        {/* MY AWARDS FOLLOWING YEAR */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
            <Typography variant="h6">My Awards</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {myAwardsFollowingYear.length !== 0 && (
                <Grid item xs={12} className ={classes.tableContainer}>
                    <TableContainer component={Paper}>
                        <Table size="small" className={classes.table}>
                          <TableHead>
                            <TableRow>
                              <TableCell>Vacation Number</TableCell>
                              <TableCell>Bid Rank</TableCell>
                              <TableCell>Start Date</TableCell>
                              <TableCell>Inclusive End Date</TableCell>
                              <TableCell>Number of Days</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                          {myAwardsFollowingYear && _map(myAwardsFollowingYear, i => (
                            <TableRow key={i.id} className={classes.tableRow}>
                              <TableCell align="left">{i.vacationNumber}</TableCell>
                              <TableCell align="left">{i.bidRank}</TableCell>
                              <TableCell align="left">{commonFunctions.formatDate_Date(i.startDate)}</TableCell>
                              <TableCell align="left">{commonFunctions.formatDate_Date(i.inclusiveEndDate)}</TableCell>
                              <TableCell align="left">{commonFunctions.calculateNumberOfDays(i.startDate, i.inclusiveEndDate)}</TableCell>
                            </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* ALL AWARDS FOLLOWING YEAR */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">All Awards</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
                  <Grid item xs={12} className ={classes.tableContainer}>
                  {allAwardsFollowingYear && _map(allAwardsFollowingYear, (object, index) => (
                    <Accordion key={index}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummaryBlue}>
                        <Typography variant="body1">{commonFunctions.formatMonth(object[0].month)}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <TableContainer component={Paper}>
                            <Table size="small" className={classes.table}>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Name</TableCell>
                                  <TableCell>Start Date</TableCell>
                                  <TableCell>Inslusive End Date</TableCell>
                                  <TableCell>Number of Days</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                              {_map(object, (innerObject, innerIndex) => (
                                <TableRow key={innerObject.id} className={classes.tableRow}>
                                  <TableCell align="left">{innerObject.employeeName}</TableCell>
                                  <TableCell align="left">{commonFunctions.formatDate_Date(innerObject.startDate)}</TableCell>
                                  <TableCell align="left">{commonFunctions.formatDate_Date(innerObject.inclusiveEndDate)}</TableCell>
                                  <TableCell align="left">{commonFunctions.calculateNumberOfDays(innerObject.startDate, innerObject.inclusiveEndDate)}</TableCell>
                                </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                        </TableContainer>
                      </AccordionDetails>
                      </Accordion>
                      ))}
                  </Grid>
              </Grid>
          </AccordionDetails>
        </Accordion>
        {/* SLOTS AVAILABLE FOLLOWING YEAR*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Slots Available</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
                  <Grid item xs={12} className ={classes.tableContainer}>
                  {slotsAvailableFollowingYear && _map(slotsAvailableFollowingYear, (object, index) => (
                    <Accordion key={index}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummaryBlue}>
                        <Typography variant="body1">{commonFunctions.formatMonth(object[0].month)}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <TableContainer component={Paper}>
                            <Table size="small" className={classes.table}>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Date</TableCell>
                                  <TableCell>Starting Count</TableCell>
                                  <TableCell>Count of Awards</TableCell>
                                  <TableCell>Available Slots</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                              {_map(object, (innerObject, innerIndex) => (
                                <TableRow key={innerObject.id} className={classes.tableRow}>
                                  <TableCell align="left">{commonFunctions.formatDate_Date(innerObject.slotDate)}</TableCell>
                                  <TableCell align="left">{innerObject.startingSlotCount}</TableCell>
                                  <TableCell align="left">{innerObject.countOfAwards}</TableCell>
                                  <TableCell align="left">{innerObject.availSlotsForDay}</TableCell>
                                  
                                </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                        </TableContainer>
                      </AccordionDetails>
                      </Accordion>
                      ))}
                  </Grid>
              </Grid>
          </AccordionDetails>
        </Accordion>
      </div>

      <Dialog
          open={open_ErrorDialog}
          fullWidth
          maxWidth="sm"
      >
          <DialogTitle>Error</DialogTitle>
          <DialogContent dividers>
              <Typography gutterBottom>
                  {errorDialogMessage}
              </Typography>
          </DialogContent>
          <DialogActions>
              <Button onClick={handleClose_ErrorDialog} color="primary" autoFocus>
                  Ok
              </Button>
          </DialogActions>
      </Dialog>
      
      {showLoader && <CircularProgress className={classes.loader} />}
  </>
  )
}

export default Info;